import React from 'react'
import { Trans, useTranslation } from 'lib/i18n'
import { pushToDataLayer } from 'lib/tracking'

import Link from 'components/Link/Link'
import { Box } from 'components/UI/Box/Box'
import { Button } from 'components/UI/Button/Button'
import {
  BodySmallBold,
  DesktopH2,
  H1,
  H4,
  H5,
  H6,
} from 'components/UI/Typography/Typography.new'

import styles from './BusinessPageStats.module.css'

const BusinessPageStats = (): JSX.Element => {
  const { t } = useTranslation()

  const logCta = () =>
    pushToDataLayer({
      event: 'findYourTalentClick',
    })

  return (
    <div className={styles.wrapper} data-cy="businessPageStats">
      <div className={styles.title}>
        <DesktopH2 element="h2">
          <Trans i18nKey="BusinessPageStats.title1">
            <span className={styles.blue}>Celebrities </span>give results
          </Trans>
        </DesktopH2>
      </div>

      <div className={styles.statistics}>
        <Box hideFooter className={styles.statBox}>
          <div className={styles.statNumber}>
            <span className={styles.blue}>8</span>/10
          </div>
          <div className={styles.statDescription}>
            <H6>
              {t(
                'BusinessPageStats.statDescription11',
                'consumers have purchased something based on a celebrity endorsement',
              )}
            </H6>
          </div>
          <BodySmallBold>Rakuten Marketing, 2019</BodySmallBold>
        </Box>

        <Box hideFooter className={styles.statBox}>
          <div className={styles.statNumber}>
            {t('BusinessPageStats.statDescription2statPrefix', '$')}
            <span className={styles.blue}>
              {t('BusinessPageStats.statDescription2statValue', '5.78')}
            </span>
            {t('BusinessPageStats.statDescription2statSuffix', '')}
          </div>
          <div className={styles.statDescription}>
            <H6>
              {t(
                'BusinessPageStats.statDescription2',
                'earned on every dollar spent on influencer marketing campaigns',
              )}
            </H6>
          </div>
          <BodySmallBold>
            Influencer Marketing Benchmark Report, 2019
          </BodySmallBold>
        </Box>

        <Box hideFooter className={styles.statBox}>
          <div className={styles.statNumber}>
            <span className={styles.blue}>71</span>%
          </div>
          <div className={styles.statDescription}>
            <H6>
              {t(
                'BusinessPageStats.statDescription41',
                'of marketers say the quality of traffic coming from celebrity marketing is better than other sources',
              )}
            </H6>
          </div>
          <BodySmallBold>Mediakix, 2021</BodySmallBold>
        </Box>
      </div>

      <Box className={styles.factBox}>
        <H1 element="h3">{t('BusinessPageStats.quickFacts', 'Quick facts')}</H1>
        <div className={styles.facts}>
          <div className={styles.factBlock}>
            <H6 block>
              {t('BusinessPageStats.averagePrice', 'Average price')}
            </H6>
            <H4>{t('BusinessPageStats.averagePriceAmount', '$900')}</H4>
          </div>
          <div className={styles.factBlock}>
            <H6 block>
              {t('BusinessPageStats.averageTime', 'Average delivery time')}
            </H6>
            <H4>
              {t('BusinessPageStats.averageDays', '3.2 days + revisions')}
            </H4>
          </div>
          <div className={styles.factBlock}>
            <H6 block>
              {t(
                'BusinessPageStats.talentToChoose1',
                'Celebrities to choose from',
              )}
            </H6>
            <H4>{t('BusinessPageStats.talentAmount1', '6000+')}</H4>
          </div>
          <div className={styles.factBlock}>
            <H6 block>{t('BusinessPageStats.feedback', 'Feedback')}</H6>
            <H4>
              <Trans i18nKey="BusinessPageStats.rating">
                {'97% '}
                <span style={{ fontSize: 18 }}>
                  Rate the video 4/5 or higher
                </span>
              </Trans>
            </H4>
          </div>
        </div>
      </Box>

      <div className={styles.findTalentText}>
        <H5>
          {t(
            'BusinessPageStats.findTalentText',
            'Memmo is your short-cut to talent that will make a difference!',
          )}
        </H5>
      </div>

      <Link href="/page/business-form">
        <a data-cy="businessPageStatsCta">
          <Button
            onClick={logCta}
            className={styles.findTalentButton}
            type="blue"
          >
            {t('BusinessPageStats.cta', 'Contact our team')}
          </Button>
        </a>
      </Link>
    </div>
  )
}

export default BusinessPageStats
